import dayjs, { Dayjs } from 'dayjs';
import { Loader2, Clock, XCircle } from 'lucide-react';
import React from 'react';

interface StatusBadgeProps {
  expiry?: Dayjs;
  loading?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ expiry, loading = false }) => {
  const now = dayjs();

  if (loading) {
    return (
      <div
        className="inline-flex items-center gap-1 bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm font-medium animate-pulse"
        role="status"
        aria-live="polite"
      >
        <Loader2 size={16} className="animate-spin" aria-hidden="true" />
        Loading...
      </div>
    );
  }

  if (!expiry) {
    return (
      <div
        className="inline-flex items-center gap-1 bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium"
        role="status"
        aria-live="polite"
      >
        <XCircle size={16} aria-hidden="true" />
        Not Subscribed
      </div>
    );
  }

  const isActive = expiry.isAfter(now);
  const formattedDate = expiry.format('MMM D, YYYY [at] h:mm A');

  return (
    <div
      className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium ${
        isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
      }`}
      role="status"
      aria-live="polite"
      title={formattedDate}
    >
      {isActive ? (
        <>
          <Clock size={16} aria-hidden="true" />
          Expires on {formattedDate}
        </>
      ) : (
        <>
          <XCircle size={16} aria-hidden="true" />
          Expired
        </>
      )}
    </div>
  );
};
